



































import { defineComponent, ref } from '@vue/composition-api'
import Strech from '@/components/animation/Strech.vue'
import ZoomOutImg from '@/components/animation/ZoomOutImg.vue'
import { motionOK } from '@/inc/utils/motionOK'
import gsap from 'gsap'

export default defineComponent({
  name: 'quote',
  components: {
    Strech,
    ZoomOutImg,
  },
  props: {
    content: {
      required: true,
      type: Object,
    },
  },
  setup() {
    const contentRef = ref()
    const visualRef = ref()

    const animateIn = () => {
      if (motionOK()) {
        const TL = gsap.timeline({
          defaults: {
            duration: 1,
            ease: 'power4.out',
          },
        })

        if (contentRef.value) {
          TL.add(contentRef.value.getTween(), 'start')
        }

        if (visualRef.value) {
          TL.add(visualRef.value.getTween().resume(), 'start+=0.25')
        }
      }
    }

    return {
      animateIn,
      contentRef,
      visualRef,
    }
  },
})
